module.exports = __webpack_public_path__ + "static/media/modal.17bec47f.png";